import { render, staticRenderFns } from "./TreeMenuV2.vue?vue&type=template&id=6e3bad4a&scoped=true&"
import script from "./TreeMenuV2.vue?vue&type=script&lang=js&"
export * from "./TreeMenuV2.vue?vue&type=script&lang=js&"
import style0 from "./TreeMenuV2.vue?vue&type=style&index=0&id=6e3bad4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3bad4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VIcon,VListItem})
